export default __webpack_public_path__ + "static/media/education_mobile.e2c2246f.webp";